import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
  BooleanOrNullOrUndefined,
} from 'src/app/shared/utils';

export class ClientCommunications {
  id?: number;
  patient_id?: number;
  month?: number;
  year?: number;
  comments?: string;
  schedule?: string;
  phone_call?: boolean;
  text_message?: boolean;
  email_sent?: boolean;
  created_at?: string | Date;
  updated_at?: string | Date;
  deleted_at?: string | Date;

  constructor(data?: Partial<ClientCommunications>) {
    Object.assign(this, data);
  }

  static build = (
    data: Partial<ClientCommunications>
  ): ClientCommunications => ({
    ...data,
    id: NumberOrNullOrUndefined(data.id),
    patient_id: NumberOrNullOrUndefined(data.patient_id),
    month: NumberOrNullOrUndefined(data.month),
    year: NumberOrNullOrUndefined(data.year),
    comments: StringOrNullOrUndefined(data.comments),
    schedule: StringOrNullOrUndefined(data.schedule),
    phone_call: BooleanOrNullOrUndefined(data.phone_call),
    text_message: BooleanOrNullOrUndefined(data.text_message),
    email_sent: BooleanOrNullOrUndefined(data.email_sent),
    created_at: data.created_at ? new Date(data.created_at) : undefined,
    updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
    deleted_at: data.deleted_at ? new Date(data.deleted_at) : undefined,
  });
}

export interface CaseCommunicationsResponse {
  patient_id: number;
  communications: ClientCommunications[];
}

